// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"535fe719","453":"3e5c68c2"}[chunkId] + ".chunk.js";
};